var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-payment"},[_c('span',{staticClass:"cart-payment-span"},[_vm._v("TOTAL")]),_vm._v(" "),_c('span',{staticClass:"cart-payment-value"},[_vm._v(_vm._s(_vm.p_total))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c283250","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Total.vue
// module id = 141
// module chunks = 0